import React from 'react';
import { observer } from 'mobx-react';
import Select from '../../../core/form/Select';
import { toJS } from 'mobx';
import DraftItemExtraColumnService from '../services/DraftItemExtraColumnService';

class DraftItemExtraColumnsContainer extends React.Component {
  componentDidMount() {
    DraftItemExtraColumnService.init();
  }

  render() {
    return (
      <Select
        mode="multiple"
        placeholder="Extra columns to show"
        value={toJS(DraftItemExtraColumnService.columns)}
        onChange={(value) => DraftItemExtraColumnService.handleChange(value)}
        options={[
          { value: 'answers', label: 'Answers' },
          { value: 'audio', label: 'Audio' },
          { value: 'character.name', label: 'Character' },
          { value: 'grammar.name', label: 'Grammar' },
          { value: 'image', label: 'Image' },
          { value: 'draftCreationReason', label: 'Justification' },
          { value: 'translation', label: 'Translate (PT)' },
          { value: 'spanishTranslation', label: 'Translate (ES)' },
          { value: 'postPhrase', label: 'Post Phrase' },
          { value: 'postPhraseAudio', label: 'Post Phrase Audio' },
          { value: 'postPhraseImage', label: 'Post Phrase Image' },
          { value: 'title', label: 'Title' },
          { value: 'titleAudio', label: 'Title Audio' },
          { value: 'videoExternalLink', label: 'Video' },
          { value: 'audioAssetsStatus', label: 'Status Audio' },
          { value: 'imageAssetsStatus', label: 'Status Image' },
          { value: 'videoAssetsStatus', label: 'Status Video' },
        ]}
        formItemStyle={{ margin: 0, minWidth: 250, maxWidth: 750 }}
      />
    );
  }
}

export default observer(DraftItemExtraColumnsContainer);
